import { render, staticRenderFns } from "./DashboardComercio.vue?vue&type=template&id=c7bb405a&"
import script from "./DashboardComercio.vue?vue&type=script&lang=js&"
export * from "./DashboardComercio.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComercio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports